import { render, staticRenderFns } from "./winaction.vue?vue&type=template&id=9bffe3b4"
import script from "./winaction.vue?vue&type=script&lang=js"
export * from "./winaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports